import {
  DocumentClassAttributes,
  MaterialAttributes,
  OrderDetailAttributes,
  SubRouteAttributes,
  VisitAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/status.enum";
import ReturnTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/return-type/return-type.entity";
import { CommonModule, DecimalPipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";

// SmartGrid Imports
import {
  SmartGridComponent,
  ColDef,
  GridConfig,
  PageChangedEvent,
  SortChangedEvent,
  GridReadyEvent,
} from 'app/shared/components/smart-grid';
import { RouteUserCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/route-user-cell-renderer/route-user-cell-renderer.component';
import { DateHourCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/date-hour-cell-renderer/date-hour-cell-renderer.component';
import { CustomerCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/customer-cell-renderer/customer-cell-renderer.component';
import { MaterialCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/material-cell-renderer/material-cell-renderer.component';
import { QuantityCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/quantity-cell-renderer/quantity-cell-renderer.component';
import { CurrencyCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/currency-cell-renderer/currency-cell-renderer.component';
import { ActionsCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/actions-cell-renderer/actions-cell-renderer.component';

import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { MaterialsManagementFiltersComponent } from "app/modules/components/filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { ChangeConditionService } from "app/modules/components/master/change-condition/change-condition.service";
import { MaterialService } from "app/modules/components/material/material/material.service";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { MasterUserInterface } from "app/modules/components/sales/order-generate/interfaces/master-user.interface";
import { OrdersListService } from "app/modules/components/sales/order-list-components/order-list.service";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
  takeUntil,
} from "rxjs";
import {
  ORDER_RETURN_EXPORT_ID,
  ORDER_RETURN_TITLE,
} from "../order-customer/exports/order-customer.constants";
import { OrderCustomerExport } from "../order-customer/exports/order-customer.export";
import { OrderCustomerService } from "../order-customer/order-customer.service";
import { DateHelper } from "app/utils/date.helper";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DecimalConfigService } from "app/services/decimal-config.service";
import { UnitMeasureDisplayComponent } from "app/shared/components/unit-measure-display/unit-measure-display.component";
import { BusinessPartnerCellRendererComponent } from "app/modules/components/monitor/monitor-routes/cell-renderers/business-partner-cell-renderer.component";
import { Router } from "@angular/router";
import { TripCellRendererComponent } from "../../visits/visit-report/cell-renderers/trip-cell-renderer.component";

@Component({
  selector: "app-return-product",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    SmartGridComponent, // Added for SmartGrid migration
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    HoverMenuDirective,
    MatSelectModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    FormatOtherDateHourPipe,
    FilterComponent,
    MatAutocompleteModule,
    MatCheckboxModule,
    DecimalFormatPipe,
    DocumentFlowButtonComponent,
    MatMenuModule,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FilterSectionComponent,
    UserRouteDisplayComponent,
    UnitMeasureDisplayComponent,
    CompanyCurrencyPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    OrderCustomerExport,
    DecimalPipe,
  ],
  templateUrl: "./return-product.component.html",
  styleUrl: "./return-product.component.scss",
})
export class ReturnProductComponent implements OnInit, OnDestroy {
  getCode = getCode;

  StatusEnum = StatusEnum;
  OrderStatusERPEnum = OrderStatusERPEnum;
  DocumentTypeEnum = DocumentTypeEnum;
  type = DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO; //devolución de producto

  decimalPipe = new DecimalPipe("en-US");

  displayedColumns: string[] = [
    "routeUser",
    "serials",
    "date",
    "returnType",
    "shipToExternalKeyCode",
    "materialName",
    "soldQuantity",
    //"baseUnitOfMeasure",
    "unitPrice",
    "subTotal",
    "total",
    "actions",
  ];

  dataSource = new MatTableDataSource<OrderDetailAttributes>([]);

  // SmartGrid properties
  data: any[] = [];
  loading: boolean = false;
  columnDefs: ColDef<any>[] = [];
  gridConfig: GridConfig<any> = {
    rowIdField: "_id" as any,
    emptyState: {
      message: "No encontramos tus resultados!",
      showIcon: true,
    },
    pagination: {
      enabled: true,
      mode: "api",
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
    },
    sorting: {
      enabled: true,
      mode: "api",
      multiColumn: false,
      defaultSort: [{ field: "_id" as any, direction: "desc" }],
    },
    search: {
      enabled: false,
    },
    columnFilters: {
      enabled: true,
      mode: "local",
    },
    columnVisibility: {
      enabled: false, // Disabled - now in settings panel
    },
    selection: {
      enabled: false,
    },
    autoSizing: {
      enabled: true,
      includeHeaders: true,
      skipHidden: true,
      padding: 40, // Increased for more spacing
    },
    styling: {
      maxHeight: "85vh",
      minHeight: "80vh",
      density: "comfortable",
      fontSize: "12px",
      cellPaddingX: "3px",
      cellPaddingY: "3px",
    },
    settingsPanel: {
      enabled: true,
      position: "right",
      enableColumnVisibility: true,
      defaultDensity: "compact",
    },
  };

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderDetailAttributes = "_id";
  sortDirection: "ASC" | "DESC" = "DESC";

  filter = {
    dateini: new Date(),
    dateend: new Date(),
    warehouseId: null,
    item: null,
    documentType: null,
    userId: null,
    soldTo: null,
    shipTo: null,
    returnType: null,
    state: null,
    routes: [],
    company: null,
    status: null,
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });

  warehouseList: WarehouseAttributes[] = [];
  warehouseFilterList: WarehouseAttributes[] = [];
  searchWarehouse = "";

  subRouteList: SubRouteAttributes[] = [];
  listFilterSubRouteList: SubRouteAttributes[] = [];
  searchSubRoute = "";

  UMPActive: boolean;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];

  sellerList: MasterUserInterface[] = [];
  sellerFilterList: MasterUserInterface[] = [];
  searchSeller = "";
  documentClassesList: DocumentClassAttributes[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  selectSeller: string = "0";

  searchMaterial = "";
  searchReturnType = "";
  materialList: MaterialAttributes[] = [];
  returnTypeList: ReturnTypeAttributes[] = [];
  private searchSubject = new Subject<string>();

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: OrderStatusERPEnum.ORDER_PENDING, name: "Devolución pendiente" }, // 0
    { id: OrderStatusERPEnum.ORDER_ERROR, name: "Error enviando a ERP" }, // 4
    { id: OrderStatusERPEnum.ORDER_SEND, name: "Devolución enviado a ERP" }, // 1
    {
      id: OrderStatusERPEnum.ORDER_RECEIVED,
      name: "Devolución recibido por ERP",
    }, // 2
    { id: OrderStatusERPEnum.ORDER_CREATED, name: "Devolución creado en ERP" }, // 3
  ];
  selectedStatusERP: number[] = [];
  isStatusErpIndeterminate = false;
  isStatusErpChecked = false;
  statusFilterCtrlErp = new FormControl();
  filteredStatusERP: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private _onDestroy = new Subject<void>();

  orderStatusList = [
    { id: null, name: "Todos" },
    { id: StatusEnum.INACTIVE, name: "Anulado" }, // 0
    { id: StatusEnum.ACTIVE, name: "Creado" }, // 1
    { id: StatusEnum.ORDER_IN_PROGRESS, name: "En proceso de aprobación" }, // 6
    { id: StatusEnum.ORDER_APPROVED, name: "Aprobado" }, // 7
    { id: StatusEnum.ORDER_REJECTED, name: "Rechazado" }, // 8
    { id: StatusEnum.ORDER_DELIVERED, name: "Entregado por cliente" }, // 9
    {
      id: StatusEnum.ORDER_PARTIAL_DELIVERED,
      name: "Entregado parcialmente por el cliente",
    }, // 10
    {
      id: StatusEnum.ORDER_DELIVERY_REJECTED,
      name: "No entregado por cliente",
    }, // 11
    { id: StatusEnum.ORDER_PARTIAL_APPROVED, name: "Aprobado parcialmente" }, // 14
  ];
  selectedStatus: number[] = [];
  isStatusIndeterminate = false;
  isStatusChecked = false;
  filteredStatus: BehaviorSubject<any[]> = new BehaviorSubject([]);
  statusFilterCtrl = new FormControl();

  form: FormGroup;

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private orderCustomer: OrderCustomerService,
    private readonly warehouseService: WarehouseService,
    private readonly subRouteService: SubRouteService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private orderCustomerExport: OrderCustomerExport,
    private ordersListService: OrdersListService,
    private readonly cdr: ChangeDetectorRef,
    private readonly materialService: MaterialService,
    private changeConditionService: ChangeConditionService,
    private fb: FormBuilder,
    private companyCurrencyPipe: CompanyCurrencyPipe,
    private decimalConfigService: DecimalConfigService,
    private readonly router: Router
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
    });
  }

  goToTravel(element: VisitAttributes) {
        if (element.trip?.id) {
          const queryParams = { tripId: element.trip.id };
          const urlTree = this.router.createUrlTree(['monitor', 'principal-screen'], { queryParams });
          const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
          window.open(absoluteUrl, '_blank');
        }
      }

  private formatCurrency(value: number): string {
    if (value == null) return "-";
    const decimals = this.decimalConfigService.getDecimals();
    const formattedNum =
      this.decimalPipe.transform(value, `1.${decimals}-${decimals}`) ?? "-";
    if (formattedNum === "-") return "-";
    const symbol = this.companyCurrencyPipe.transform("symbol");
    return `${symbol} ${formattedNum}`;
  }

  private createCurrencyFilterOptions(fieldPath: string) {
    return {
      valueExtractor: (item: any) => {
        const value = item[fieldPath];
        return this.formatCurrency(value);
      },
      customFilterFn: (rowData: any, filterValue: string) => {
        const value = rowData[fieldPath];
        const formattedValue = this.formatCurrency(value);
        if (!formattedValue || formattedValue === "-") return !filterValue;
        return formattedValue === filterValue;
      },
    };
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.fetchCompanies();
    // this.fetchAllWarehouses();
    this.onFilter();
    // this.getAllRutas();

    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((filterValue: string) => {
        this.pageIndex = 1;
        this.search = filterValue;
        this.onFilter();
      });

    this.setupMaterialSearchControl();
    this.getMaterialList();

    this.soldToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }
        this.soldToList = [];
        this.soldToFilterSelected = null;
        this.getListSoldTo(value);

        this.getListReport();
      });

    this.shipToControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.shipToList = [];
        this.getListShipTo(value);
        this.getListReport();
      });

    this.filteredStatusERP.next(this.orderStatusErpList);
    this.statusFilterCtrlErp.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatusERP();
      });

    this.filteredStatus.next(this.orderStatusList);
    this.statusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatus();
      });
  }

  ngOnInit(): void {
    this.initializeColumnDefs();
    this.onHandleSearch();
    // this.getListSeller();
    // this.getListSoldTo(null);
    // this.getListShipTo(null);
    // this.getTypeReturnList();
  }

  private initializeColumnDefs(): void {
    this.columnDefs = [
      {
        field: "subRoute.code" as any,
        headerName: "Ruta - Usuario",
        minWidth: 300,
        sortable: true,
        pinned: "left",
        cellRenderer: RouteUserCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const subRoute = item.subRoute;
            const user = item.user;
            const routeName = subRoute?.name ?? "-";
            const userName = user?.name ?? "-";
            return `${routeName} - ${userName}`;
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const subRoute = rowData.subRoute;
            const user = rowData.user;
            const routeName = subRoute?.name ?? "-";
            const userName = user?.name ?? "-";
            const displayValue = `${routeName} - ${userName}`;
            if (!displayValue || displayValue === "- - -") return !filterValue;
            return displayValue === filterValue;
          },
        },
      },          
      {
        field: 'trip.id',
        headerName: 'Viaje',
        minWidth: 150,
        sortable: true,
        cellRenderer: TripCellRendererComponent,
        cellRendererParams: {
        onTripClick: (data: any) => this.goToTravel(data)
        }
      },
      {
        field: "serials",
        headerName: "Nro. Doc.",
        minWidth: 160,
        sortable: true,
      },
      {
        field: "date",
        headerName: "Fecha",
        minWidth: 140,
        sortable: true,
        cellRenderer: DateHourCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const date = item.date;
            if (!date) return "-";
            return new Date(date).toLocaleDateString("es-ES");
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const date = rowData.date;
            if (!date) return !filterValue;
            const formattedDate = new Date(date).toLocaleDateString("es-ES");
            return formattedDate === filterValue;
          },
        },
      },
      {
        field: "returnType.name" as any,
        headerName: "Motivo de Devolución",
        minWidth: 200,
        sortable: true,
        valueFormatter: (value: any, data: any) =>
          data?.returnType?.name || "-",
      },
      {
        field: "soldTo.name",
        headerName: "Pagador/Receptor",
        cellRenderer: BusinessPartnerCellRendererComponent,
        autoSize: true,
        minWidth: 250, // Much wider for code + long name
        sortable: true,
        filterOptions: {
          // Display customer name in filter dropdown instead of code
          // Note: Requires shipToName field to be present in row data
          valueExtractor: (item: any) => item?.soldTo?.name,
          customFilterFn(rowData, filterValue) {
            const rowCustomer = rowData?.soldTo?.name;
            if (!rowCustomer) return !filterValue;

            return rowCustomer === filterValue;
          },
        },
      },
      {
        field: "materialName.name" as any,
        headerName: "Material",
        minWidth: 200,
        sortable: true,
        cellRenderer: MaterialCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            return item.materialName?.name ?? "-";
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const value = rowData.materialName?.name;
            if (!value || value === "-") return !filterValue;
            return value === filterValue;
          },
        },
      },
      {
        field: "soldQuantity",
        headerName: "Cantidad (U.M)",
        minWidth: 180,
        sortable: true,
        cellRenderer: QuantityCellRendererComponent,
        cellRendererParams: {
          getUMPActive: () => this.UMPActive, // Arrow function para valor dinámico
        },
      },
      {
        field: "unitPrice",
        headerName: "Precio",
        minWidth: 120,
        sortable: true,
        cellClass: "text-right",
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions("unitPrice"),
      },
      {
        field: "subTotal",
        headerName: "Subtotal",
        minWidth: 120,
        sortable: true,
        cellClass: "text-right",
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions("subTotal"),
      },
      {
        field: "total",
        headerName: "Total",
        minWidth: 120,
        sortable: true,
        cellClass: "text-right",
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions("total"),
      },
      {
        colId: "actions",
        headerName: "",
        minWidth: 80,
        maxWidth: 80,
        sortable: false,
        pinned: "right",
        cellRenderer: ActionsCellRendererComponent,
      },
    ];
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.onFilter();
      }
    );
  }

  onFilter() {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });

    this.getListReport();
  }

  onClearFilter() {
    this.filter = {
      dateini: new Date(),
      dateend: new Date(),
      warehouseId: null,
      item: null,
      documentType: null,
      userId: null,
      soldTo: null,
      shipTo: null,
      returnType: null,
      state: null,
      routes: [],
      company: null,
      status: null,
    };
    this.range.reset({
      start: new Date(),
      end: new Date(),
    });
    const today = new Date();
    this.form.reset({ start: today, end: today });
    this.onFilter();
    this.selectSeller = "0";
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getListReport();
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction?.toUpperCase() || "ASC";
    this.getListReport();
  }

  changePage(e) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getListReport();
  }

  // SmartGrid event handlers
  onPageChanged(event: PageChangedEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getListReport();
  }

  onSortChanged(event: SortChangedEvent<any>): void {
    if (event.sortStates.length > 0) {
      const sortState = event.sortStates[0];
      this.sortActive = sortState.field as keyof OrderDetailAttributes;
      this.sortDirection = sortState.direction === "asc" ? "ASC" : "DESC";
    } else {
      this.sortActive = "_id";
      this.sortDirection = "DESC";
    }
    this.getListReport();
  }

  onGridReady(event: GridReadyEvent<any>): void {
    // Grid is ready, can store reference if needed
  }

  getListReport() {
    this.loading = true;

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField(),
      sortDirection: this.sortDirection,
    };

    // let filter = {
    //   type: DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO, // DEVOLUCIÓN DE PRODUCTO
    //   start: adjustedStart.toISOString(), // Convertir a UTC
    //   end: adjustedEnd.toISOString(),     // Convertir a UTC
    //   seller: this.selectSeller !== "0" ? this.selectSeller : null,
    //   soldTo: this.soldToControl.value,
    //   shipTo: this.shipToControl.value,
    //   returnType: this.filter.returnType,
    //   statusERP: this.selectedStatusERP.length ? this.selectedStatusERP : null,
    //   status: this.selectedStatus.length ? this.selectedStatus : null,
    // };

    let filter = {
      type: this.type,
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
      startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
      endTrip:
        DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ??
        null,
      end_startTrip: DateHelper.getStartOfDay(
        this.form.get("end_startTrip")?.value
      ),
      end_endTrip:
        DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ??
        null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value, //
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value, //
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      typeCustomer: this.selectedCustomerType.length
        ? this.selectedCustomerType
        : null,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,
      ordersToFilter: null,
    };

    this.orderCustomer.findAllWithCount(options, filter).subscribe({
      next: (res: IPaginationResult<OrderDetailAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.snackBar.open(
          err.error.message || "Error al obtener reporte",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getSortField(): keyof OrderDetailAttributes {

    return this.sortActive;
  }

  //filter
  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
      }
    });
  }

  private fetchAllWarehouses(): void {
    this.warehouseService.findToComboBox().subscribe({
      next: (res) => {
        this.warehouseList = res.data;
        this.warehouseFilterList = this.warehouseList.slice();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching warehouses",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsWarehouse(event) {
    if (!this.warehouseList) {
      return;
    }
    let search = event;
    if (!search) {
      this.warehouseFilterList = this.warehouseList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.warehouseFilterList = this.warehouseList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changueOptionsSeller(event) {
    if (!this.sellerList) {
      return;
    }
    let search = event;
    if (!search) {
      this.sellerFilterList = this.sellerList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.sellerFilterList = this.sellerList.filter(
      (item) =>
        item.masterUserId.toString().toLowerCase().indexOf(search) > -1 ||
        item.username.toString().toLowerCase().indexOf(search) > -1
    );
  }

  changeWarehouse(event): void {
    this.subRouteList = [];
    this.listFilterSubRouteList = [];
    this.getAllRutas();
  }

  private getAllRutas(): void {
    this.subRouteService
      .findToWarehouse(this.filter.warehouseId ? [this.filter.warehouseId] : [])
      .subscribe({
        next: (res) => {
          this.subRouteList = res.data;
          this.listFilterSubRouteList = this.subRouteList.slice();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching route",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  changueOptionsSubRoute(event) {
    if (!this.subRouteList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSubRouteList = this.subRouteList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSubRouteList = this.subRouteList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  fetchSoldToName = (soldToId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldToId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  changueOptionsMaterial(event) {
    this.searchSubject.next(event);
  }

  onExportButtonPressed() {
    if (!this.orderCustomerExport.canStartTask()) return;
    const dialogRef = this.matDialog.open(ExportDialogComponent, {
      data: { title: ORDER_RETURN_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderCustomerExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          ORDER_RETURN_EXPORT_ID,
          ORDER_RETURN_TITLE
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
          this.sellerFilterList = res.data.slice();
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching sellers",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: DocumentTypeEnum.FACTURA,
    };
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchMaterial = searchTerm;
          this.getMaterialList();
        }
      });
  }

  private getMaterialList(): void {
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
    };

    this.materialService
      .findAllWithCount(
        materialOptions,
        this.filter.company ? this.filter.company : []
      )
      .subscribe({
        next: (res: IPaginationResult<MaterialAttributes>) => {
          this.materialList = res?.data?.[0]?.data ?? [];
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al traer registros",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  private getTypeReturnList(): void {
    this.changeConditionService.findToComboBox("DE").subscribe({
      next: (res: IRequestResult<ReturnTypeAttributes[]>) => {
        this.returnTypeList = res?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al traer registros",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  onStatusSelectionErpChange(selected: number[]): void {
    this.selectedStatusERP = selected;
    this.updateStatusErpSelectionState();
  }

  updateStatusErpSelectionState(): void {
    const total = this.orderStatusErpList.length;
    const selected = this.selectedStatusERP.length;
    this.isStatusErpChecked = total > 0 && selected === total;
    this.isStatusErpIndeterminate = selected > 0 && selected < total;
  }

  toggleSelectAllStatusesErp(isChecked: boolean): void {
    this.selectedStatusERP = isChecked
      ? this.orderStatusErpList.map((os) => os.id)
      : [];
    this.updateStatusErpSelectionState();
  }

  filterStatusERP(): void {
    const search = this.statusFilterCtrlErp.value?.toLowerCase() || "";
    const filtered = this.orderStatusErpList.filter((os) =>
      os.name.toLowerCase().includes(search)
    );
    this.filteredStatusERP.next(filtered);
  }

  onStatusSelectionChange(selected: number[]): void {
    this.selectedStatus = selected;
    this.updateStatusSelectionState();
  }

  updateStatusSelectionState(): void {
    const total = this.orderStatusList.length;
    const selected = this.selectedStatus.length;
    this.isStatusChecked = total > 0 && selected === total;
    this.isStatusIndeterminate = selected > 0 && selected < total;
  }

  filterStatus(): void {
    const search = this.statusFilterCtrl.value?.toLowerCase() || "";
    const filtered = this.orderStatusList.filter((os) =>
      os.name.toLowerCase().includes(search)
    );
    this.filteredStatus.next(filtered);
  }

  toggleSelectAllStatuses(isChecked: boolean): void {
    this.selectedStatusERP = isChecked
      ? this.orderStatusErpList.map((os) => os.id)
      : [];
    this.updateStatusErpSelectionState();
  }
}
